import { z } from 'zod';
/**
 * Export Organization Data Response Schema
 * GET /api/v2/data-export/zip
 * Returns the organization's domain data (allowlisted, see ADR 0038) as a ZIP of JSON files
 * Response type: application/zip (Blob)
 */ // This endpoint returns a binary ZIP file, not JSON
// The response validation happens on the content-type header
export const ExportOrganizationDataResponseSchema = z.instanceof(Blob).optional();

//# sourceMappingURL=export-organization-data.schema.js.map